import * as React from 'react';

import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';

interface ISnackBarProps {
  snackBarOpen: boolean;
  stepErrorType: string;
  toggleSnackBar: (state: boolean) => void;
}

class SnackBar extends React.Component<ISnackBarProps, {}> {
  public render() {
    const {
      snackBarOpen,
      toggleSnackBar,
      stepErrorType
    } = this.props;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={snackBarOpen}
        autoHideDuration={3000}
        onClose={() => toggleSnackBar(false)}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={
          <span id="message-id">{stepErrorType}</span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={() => toggleSnackBar(false)}
          >
            <CloseIcon />
          </IconButton>
        ]}
      />
    );
  }
}

export default (SnackBar);



// WEBPACK FOOTER //
// ./src/components/common/snackbar/index.tsx